export enum SocketEventType {
  MESSAGE = 'message',
  TEST = 'test',
  STRIPE_SUBSCRIPTION_SUCCESS = 'STRIPE_SUBSCRIPTION_SUCCESS',
  USER_UPDATED = 'USER_UPDATED',
  COMMENT_POSTED = 'COMMENT_POSTED',
  POST_UPDATED = 'POST_UPDATED',
}
